<template>
  <div class="register-page">
    <status-bar />
    <div class="register-page-form">
      <icu-loader v-if="isLoading" />
      <template v-else>

        <div class="register-success">
          <div class="register-success__title">
            {{ $t($options.statuses_data[status].title) }}
          </div>
          <img
            v-if="status === $options.STATUS_TYPES.APPROVED"
            src="@/assets/img/views/RegisterFinalPage/final-page.svg"
            alt="final-page"
            class="register-success__img"
          />
          <img
            v-else
            src="@/assets/img/invalid.png"
            alt="final-page"
            class="register-success__img"
          />
          <div :class="{'center': $options.STATUS_TYPES.APPROVED !== status}">
            <div class="register-success-text">
              <p v-html="$t($options.statuses_data[status].text)"></p>
            </div>
            <icu-contacts
              v-if="$options.STATUS_TYPES.APPROVED !== status"
              email-to="support"
              view-type="horizontal"
              :show-phone="false"
            />
            <div v-if="$options.statuses_data[status].text2" class="register-success-text2">
              <p v-html="$t($options.statuses_data[status].text2)"></p>
            </div>
          </div>
        </div>
        <div class="register-page-form-actions">
          <pc-button variant="dark" @click="clickHandler">
            {{ $t($options.statuses_data[status].button) }}
          </pc-button>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import StatusBar from '@/components/views/RegisterPage/StatusBar'
import PcButton from '@/components/common/PcButton.vue'
import IcuContacts from '@/components/common/IcuContacts'
import {api} from '@/api/api'
import {constants} from '@/constants'
import IcuLoader from '@/components/common/IcuLoader'

export default {
  name: 'FormStatus',
  components: {IcuLoader, IcuContacts, PcButton, StatusBar},
  data() {
    return {
      status: '',
      isLoading: true
    }
  },
  STATUS_TYPES: constants.CHECK_STATUSES,
  statuses_data: {
    [constants.CHECK_STATUSES.ERRORS]: {
      title: 'form-status.clarify-title',
      text: 'form-status.clarify-text',
      text2: 'form-status.clarify-text2',
      button: 'form-status.denied-button-text'
    },
    [constants.CHECK_STATUSES.REJECTED]: {
      title: 'form-status.denied-title',
      text: 'form-status.denied-text',
      button: 'form-status.denied-button-text'

    },
    [constants.CHECK_STATUSES.APPROVED]: {
      title: 'form-status.ready-title',
      text: 'form-status.ready-text',
      button: 'form-status.ready-button-text'
    }
  },
  async beforeMount() {
    this.status = this.$route.params.status

    if(!this.status){
      try {
        const res = await api.auth.userInfo()
        this.status = res.data.check_status
      } catch(err){
        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)
      }
    }
      this.isLoading = false

  },
  methods: {
    async clickHandler(){
      if( this.status === this.$options.STATUS_TYPES.APPROVED) {
        await this.$router.push({name: 'document-sign'})
      } else {
        window.location.href = process.env.VUE_APP_LANDING_REDIRECT_URL
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/views/register-common.scss";

.register-page {
  background: rgba(0, 78, 96, 0.2);
}
.register-page-form {
  padding-bottom: 60px;
  margin: 60px auto 60px;

  @media (max-width: 900px) {
    margin: 0 auto;
  }
}
.register-success-text2 {
  margin-top: 10px;
}
.center {
  text-align:  center;
}

</style>

